import { useState, useEffect } from 'react'
import { supabase } from './supabase'
import Auth from './Auth'
import Home from './Home'
import JoinHousehold from './JoinHousehold'

function App() {
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)
  const [hasHousehold, setHasHousehold] = useState(null)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      setLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })

    return () => subscription.unsubscribe()
  }, [])

  useEffect(() => {
    if (!session) {
      setHasHousehold(null)
      return
    }
    supabase
      .from('household_members')
      .select('household_id')
      .eq('user_id', session.user.id)
      .limit(1)
      .then(({ data }) => setHasHousehold(!!(data && data.length > 0)))
  }, [session])

  const spinner = (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', fontFamily: "'DM Serif Display', serif",
      fontSize: '32px', color: '#1a1a18',
    }}>
      bun<span style={{ color: '#1D9E75' }}>dl</span>e
    </div>
  )

  if (loading) return spinner
  if (!session) return <Auth />
  if (hasHousehold === null) return spinner
  if (!hasHousehold) return <JoinHousehold user={session.user} onJoined={() => setHasHousehold(true)} onSignOut={() => supabase.auth.signOut()} />

  return (
    <Home
      user={session.user}
      onSignOut={() => supabase.auth.signOut()}
    />
  )
}

export default App
